export const SITES_LOCATION_MAP = "SITES_LOCATION_MAP";
